export type TFaqItem = {
  question: string
  answer: string
  /** `true` quando a resposta foi redigida a partir de copy aprovada, e não veio pronta do design. */
  needsCopyReview?: boolean
}

/**
 * FAQ da home do Novo Marketplace (Figma node 4161:23723).
 *
 * ATENÇÃO — REVISÃO DE COPY PENDENTE
 * O protótipo autora as 5 perguntas mas escreve apenas a resposta da primeira. As outras quatro
 * foram compostas a partir de texto que já existe e já foi aprovado no próprio protótipo, para não
 * inventar política comercial ou regulatória. Cada uma está marcada com `needsCopyReview` e traz a
 * fonte no comentário. Produto deve revisar antes de subir para produção.
 *
 * As duas perguntas restantes do protótipo ("Quais são as formas de apresentação / utilização da
 * Cannabis medicinal?" e "Quando eu utilizar a Cannabis medicinal, vou sentir alguma alteração
 * psicológica?") estão em grupos marcados como ocultos no Figma e por isso não entraram.
 */
export const HOME_FAQ_ITEMS: TFaqItem[] = [
  {
    // Resposta literal do design (node 4161:23810).
    question: 'O que posso encontrar na Cannect?',
    answer:
      'Na Cannect, você encontra consultas, medicamentos, cannabis medicinal, suplementos, cogumelos funcionais, dermocosméticos, itens de higiene e beleza, produtos para mamãe e bebê e soluções de acompanhamento para continuar sua jornada de cuidado.'
  },
  {
    // Fonte: "A consulta não é obrigatória para todas as compras" (aparece 3x no protótipo) +
    // "Profissionais preparados para diferentes linhas de cuidado, com agenda online" (passo 2).
    question: 'Preciso passar por uma consulta para comprar?',
    answer:
      'A consulta não é obrigatória para todas as compras. Alguns tratamentos exigem prescrição e, nesses casos, você fala com um profissional pela agenda online. Se já sabe o que procura ou já tem receita, pode seguir direto para os produtos.',
    needsCopyReview: true
  },
  {
    // Fonte: CTAs "Já tenho receita ou procuro um produto" (hero) e "Já tenho uma receita" (seção 4).
    question: 'Posso usar uma receita que já tenho?',
    answer:
      'Sim. Se você já tem uma receita, pode enviá-la e seguir direto para o tratamento, sem precisar de uma nova consulta.',
    needsCopyReview: true
  },
  {
    // Fonte: descrição da seção Cannect Cuida + seus quatro itens de apoio no protótipo.
    question: 'Como funciona o Cannect Cuida?',
    answer:
      'O Cannect Cuida ajuda a organizar as próximas etapas, registrar a evolução e conectar você aos canais responsáveis pelo seu acompanhamento, com orientação sobre os próximos passos e suporte para dúvidas do dia a dia.',
    needsCopyReview: true
  },
  {
    // Fonte: "Acompanhamento, renovação, recompra e suporte ao longo da jornada" (passo 4 de
    // "Como funciona") + item "Renovação e recompra" do footer.
    question: 'Como renovar ou recomprar meu tratamento?',
    answer:
      'Renovação, recompra e suporte fazem parte do acompanhamento. Em Meus pedidos você encontra o histórico do seu tratamento para repetir a compra, e o acompanhamento orienta quando é hora de renovar.',
    needsCopyReview: true
  }
]
